import request from "@/utils/request";

export const getOffers = (params) =>
  request.get("/offers", {
    params,
  });

export const getLineGraph = ({
  start_date,
  end_date,
  offer_id,
  metrics = "claimed",
} = {}) =>
  request.get("/offer-report", {
    params: {
      start_date,
      end_date,
      offer_id,
      metrics,
    },
  });

export const getOffer = (id) => request.get(`/offers/${id}`);
